// extracted by mini-css-extract-plugin
export default {"label":"Search_label__CmrOS","input":"Search_input__GfdDg"};